// Shared list of site videos used across components and schema generation
const videos = [
  {
    id: "CL1zC8o0ezg",
    title: "MSU's BCA Students Developing Website For Their Winter Project",
    thumbnailUrl: "https://img.youtube.com/vi/CL1zC8o0ezg/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-10T09:00:00+05:30"
  },
  {
    id: "6lkulZ40Yho",
    title: "Digital Harmony: Bridging Cultures, Empowering Voices",
    thumbnailUrl: "https://img.youtube.com/vi/6lkulZ40Yho/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-15T09:00:00+05:30"
  },
  {
    id: "5lrnnjQnYZo",
    title: "Marketing Wellness | BBA Students Winter Project",
    thumbnailUrl: "https://img.youtube.com/vi/5lrnnjQnYZo/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  },
  {
    id: "TWD9OeY8AOA",
    title: "Winter Ignites Passion Into Purpose @MSU | Winter Project of BBA students",
    thumbnailUrl: "https://img.youtube.com/vi/TWD9OeY8AOA/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  },
  {
    id: "hU1-zcsO704",
    title: "Cracking The GST Code: Empowering B. Com Students With Industry Insights",
    thumbnailUrl: "https://img.youtube.com/vi/hU1-zcsO704/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  },
  {
    id: "3pyGak9PMjA",
    title: "Website Development As Winter Project || BCA Students",
    thumbnailUrl: "https://img.youtube.com/vi/3pyGak9PMjA/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  },
  {
    id: "PbAGVqQ1LJw",
    title: "Korean Language Skills At MSU || Skill Drill",
    thumbnailUrl: "https://img.youtube.com/vi/PbAGVqQ1LJw/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  },
  {
    id: "u-uIoxp5VXI",
    title: "MSU - Skill Connect || Travel & Tourism Management",
    thumbnailUrl: "https://img.youtube.com/vi/u-uIoxp5VXI/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  },
  {
    id: "SLbEig16UI4",
    title: "Skill Connect through DIY || TNA Sikkim Students",
    thumbnailUrl: "https://img.youtube.com/vi/SLbEig16UI4/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  },
  {
    id: "yMnyVAYblk8",
    title: "Business Plan Presentation By MBA Students",
    thumbnailUrl: "https://img.youtube.com/vi/yMnyVAYblk8/hqdefault.jpg",
    description: "",
    uploadDate: "2026-05-20T09:00:00+05:30"
  }
];

export default videos;
